// Generated by CoffeeScript 2.7.0
var SPEACIAL_FIELDS, UserTaggables;

SPEACIAL_FIELDS = [
  {
    id: -1,
    title: '姓名',
    type: 'Field::UserItem',
    _hidden: false
  },
  {
    id: -4,
    title: '手机号码',
    type: 'Field::TextField',
    _hidden: false
  },
  {
    id: -16,
    title: '成员标签',
    type: 'Field::Tags',
    _hidden: false
  },
  {
    id: -17,
    title: '所在组织',
    type: 'Field::Organization',
    _hidden: false
  }
];

import TagsListContainer from 'trunks/vue/admin/compositions/tags_groups/tags_list_container.js';

import MembersTable from 'trunks/vue/admin/compositions/datable_table/members_table.js';

import Actions from 'trunks/vue/admin/components/organizations/actions.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

export default UserTaggables = Vue.extend({
  components: {
    'tag-list-container': TagsListContainer,
    'members-table': MembersTable,
    'actions': Actions
  },
  props: {
    tag: {
      type: Object
    },
    profileSchema: {
      type: Object
    },
    fieldable: {
      type: Object
    }
  },
  data: function() {
    return {
      datableGID: new Skylark.Libs.GlobalID("gid://skylark/Organization/-1"),
      resourceUrl: `/admin/tags/${this.tag.id}/taggables.json`,
      selectedRows: [],
      speacialFields: SPEACIAL_FIELDS
    };
  },
  template: `<tag-list-container extendClass="user-taggables">
  <template slot="title">
    <div class="list-title">
      <button  class="text-btn btn-primary mr-3" @click="goToTagGoups">
        <i class="slp-arrow-left primary"></i>
      </button>
      <span>{{ tag.name }}</span>
    </div>
  </template>
  <div slot="content" class="datable-table">
    <members-table :fieldable="fieldable"
                   :datableGID="datableGID"
                   :resourceUrl="resourceUrl"
                   :deleteMemberOperation='false'
                   :speacialFields='speacialFields'
                   ref="membersTableRef">
        <template slot="datable-table-summary" slot-scope='{ selectedRows }'>
          <div class="datable-table-summary justify-between">
            <actions :options="['tags']"
                     :selectedRows="selectedRows"
                     :profileSchema="profileSchema"
                     :refreshDataAfterOperation='refreshDataAfterOperationFunc'
                     @refreshSeletedRowsTags='refreshSeletedRowsTags' />
          </div>
        </template>
    </members-table>
  </div>
</tag-list-container>`,
  created: function() {
    return Turbolinks.clearCache();
  },
  methods: {
    goToTagGoups: function() {
      return Turbolinks.visit(`/admin/tag_groups/user/${this.tag.tag_group_id}`);
    },
    refreshDataAfterOperationFunc: function() {
      return this.$refs.membersTableRef.refreshData();
    },
    refreshSeletedRowsTags: function(updateTagsOptions) {
      this.$refs.membersTableRef.refreshSeletedRowsTags(updateTagsOptions);
      return this.$refs.membersTableRef.resetTableAllSelected();
    }
  }
});
